import { Component, Input} from '@angular/core';

@Component({
	selector: 'app-pageheader',
	templateUrl: './pageheader.component.html',
	styles: []
})
export class PageheaderComponent {

	@Input() rutas:any[];

	constructor() { }

}
